import React, { useState } from 'react';

const AiFAQ = ({
    title = "Frequently Asked Questions",
    faqs = [
        {
            title: "What is AI-powered background verification?",
            details: "It uses artificial intelligence to automate background checks, detect inconsistencies, and improve accuracy."
        },
        {
            title: "How long does verification take?",
            details: "Most automated checks are completed within minutes to a few hours."
        },
        {
            title: "Is the platform legally compliant?",
            details: "Yes, it follows strict data privacy and employment regulations."
        },
        {
            title: "Can it integrate with our HR software?",
            details: "Yes, APIs allow easy integration with ATS and HRMS systems."
        }
    ]
}) => {
    const [openIndex, setOpenIndex] = useState(null);
    const [hover, setHover] = useState(false);
    const [hoverIndex, setHoverIndex] = useState(null);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <section className="py-20 bg-white">
            <div className="container-padding-x mx-auto px-4 max-w-4xl">
                <div className="text-center mb-12">
                    <h2 className="text-3xl md:text-4xl font-bold text-[#3A3D46]">
                        {title}
                    </h2>
                </div>

                <div className="space-y-6">
                    {faqs.map((item, index) => (
                        <div
                            key={index}
                            className={`border-[2px] ${openIndex === index ? "border-[#168DEF] font-semibold" : "hover:border-[#3A3D46]"} group rounded-xl overflow-hidden`}
                            onMouseOver={() => { setHover(true); setHoverIndex(index); }}
                            onMouseOut={() => { setHover(false); setHoverIndex(null); }}
                        >
                            <button
                                className="w-full text-left py-[13px] pr-3 focus:outline-none"
                                onClick={() => toggleFAQ(index)}
                            >
                                <div className="flex justify-between items-center">
                                    <h2 className={`flex items-center gap-3 g-m group-hover:font-semibold ${openIndex === index ? "font-semibold" : ""} mb-0 text-[16px] max-sm:pl-3`}>
                                        <div className='max-sm:hidden bg-[#168DEF] w-1 h-8 rounded-r-3xl'></div>
                                        {item?.title}
                                    </h2>
                                    <span
                                        className={`transform transition-transform duration-300 ${openIndex === index ? "rotate-180" : "rotate-0"}`}
                                    >
                                        <svg width="32" height="32" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle opacity="0.1" cx="24.5" cy="24.5" r="24.5" fill={(hover && hoverIndex === index) ? "#168DEF" : "#3A3D46"} />
                                            <path fillRule="evenodd" clipRule="evenodd" d="M16.3904 20.5187C16.9574 19.8808 17.9343 19.8233 18.5722 20.3904L24.5 25.6595L30.4278 20.3904C31.0657 19.8233 32.0426 19.8808 32.6096 20.5187C33.1767 21.1567 33.1192 22.1335 32.4813 22.7006L25.5267 28.8824C24.9412 29.4028 24.0588 29.4028 23.4733 28.8824L16.5187 22.7006C15.8808 22.1335 15.8233 21.1567 16.3904 20.5187Z" fill={(hover && hoverIndex === index) ? "#168DEF" : "#3A3D46"} />
                                        </svg>
                                    </span>
                                </div>
                            </button>
                            <div
                                className={`transition-[max-height] duration-500 ease-in-out overflow-hidden ${openIndex === index ? "sm:max-h-40" : "max-h-0"}`}
                            >
                                <div className="px-4">
                                    <p className="g-r text-[#3A3D46]">
                                        {item?.details}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default AiFAQ;
